import { ThreadFollowUpWidget } from './ThreadFollowUpWidget';

export function MailDetailToolbar({
  onBack,
  onPrevEmail,
  onNextEmail,
  companyId,
  threadId,
  hasPrevEmail = false,
  hasNextEmail = false,
  currentIndex = -1,
  totalCount = 0,
  isLoadingNext = false,
}) {
  const displayTotal =
    typeof totalCount === 'number' && totalCount > 0
      ? totalCount.toLocaleString()
      : hasNextEmail
        ? 'many'
        : currentIndex + 1;

  return (
    <div className="flex items-center justify-between px-4 py-2.5 border-b border-gray-100 bg-white select-none">
      {/* Left Action Icons */}
      <div className="flex items-center gap-1">
        {/* Back arrow */}
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-2 px-2.5 py-1.5 text-gray-600 hover:text-gray-900 rounded-lg hover:bg-gray-100 transition-colors text-xs font-semibold"
          title="Back to inbox"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          <span className="hidden sm:inline">Back</span>
        </button>
      </div>

      {/* Right Prev/Next Email Arrows & Follow-Up Widget */}
      <div className="flex items-center gap-3">
        {companyId && threadId && (
          <ThreadFollowUpWidget companyId={companyId} threadId={threadId} />
        )}
        <div className="flex items-center gap-2 text-gray-500">
          {currentIndex >= 0 && (
            <span className="text-xs text-gray-400 font-medium select-none">
              {currentIndex + 1} of {displayTotal}
            </span>
          )}
          <div className="flex items-center gap-0.5">
            <button
              type="button"
              onClick={onPrevEmail}
              disabled={!hasPrevEmail}
              className="p-1.5 hover:text-gray-900 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:cursor-not-allowed"
              title="Previous email"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
            <button
              type="button"
              onClick={onNextEmail}
              disabled={!hasNextEmail || isLoadingNext}
              className="p-1.5 hover:text-gray-900 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:cursor-not-allowed"
              title={isLoadingNext ? 'Loading next emails…' : 'Next email'}
            >
              {isLoadingNext ? (
                <svg
                  className="w-4 h-4 animate-spin text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              ) : (
                <svg
                  className="w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
